/**
 * @file The named queries each Analytics page tab puts on screen. Consumers: the
 * page shell, which reads them for the period caption, granted level, "Last
 * computed" and the `forbiddenLevel` fallback, and each tab panel, which starts
 * them; the shell starts none. An entry with a `period` is asked at that period
 * whatever the page period; one with `levels` is asked at the mapped level and
 * not at all where it maps to null. The shell takes caption and level only from
 * entries with neither. Projects asks at YTD, having no period control. Reports
 * and Metrics put no live tab answer on screen, so the shell reads neither.
 */
import type { AnalyticsTab, AnalyticsTabQuery } from './index.types';

const PERSON_TABLE_LEVELS = { self: 'team', team: 'team', org: 'org' } as const;

const TEAM_TABLE_LEVELS = { self: null, team: null, org: 'org' } as const;

export const ANALYTICS_TAB_QUERIES: Record<
  AnalyticsTab,
  readonly AnalyticsTabQuery[]
> = {
  overview: [
    { query: 'salesClosedTotal' },
    { query: 'quoteValueTotal' },
    { query: 'salesClosedByMonth', period: 'ytd' },
    { query: 'quoteValueByMonth', period: 'ytd' },
    { query: 'salesClosedByPerson', levels: PERSON_TABLE_LEVELS },
    { query: 'quoteValueByPerson', levels: PERSON_TABLE_LEVELS },
    { query: 'salesClosedByTeam', period: 'ytd', levels: TEAM_TABLE_LEVELS },
    { query: 'quoteValueByTeam', period: 'ytd', levels: TEAM_TABLE_LEVELS },
    { query: 'pipelineByStage' },
  ],
  projects: [{ query: 'projectsByStage' }],
  orders: [{ query: 'orderLinesTotals' }, { query: 'orderLinesList' }],
  invoicing: [
    { query: 'invoiceTotals' },
    { query: 'orderLinesTotals' },
    { query: 'receivableAging' },
    { query: 'invoiceList' },
  ],
  reports: [],
  metrics: [],
};
